import createGetFormSyncWarnings from '../selectors/getFormSyncWarnings';
import immutable from '../structure/immutable';

export default createGetFormSyncWarnings(immutable);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/es/immutable/getFormSyncWarnings.js
// module id = 1201
// module chunks = 0